import { forwardRef, memo } from 'react';
import { useTranslation } from 'react-i18next';
import type { TextFieldProps } from '@mui/material';
import { CircularProgress, FormHelperText } from '@mui/material';
import { StyledLabel, StyledTextField, Wrapper } from './LookupField.styles';
import { ExpandMore } from '@mui/icons-material';

export type LookupFieldProps = Omit<TextFieldProps, 'select'> & {
  helperText?: string;
  label?: string;
  disableHelperText?: boolean;
  background?: 'transparent' | 'white';
  loading?: boolean;
};

export const LookupField = memo(
  forwardRef<HTMLDivElement, LookupFieldProps>(
    ({ label, helperText, disableHelperText = false, error, background = 'white', loading = false, className, InputProps, ...rest }, ref) => {
      const { t } = useTranslation();
      return (
        <Wrapper className={className}>
          <StyledLabel>{label}</StyledLabel>
          <StyledTextField
            ref={ref}
            fullWidth
            variant="outlined"
            error={Boolean(error)}
            background={background}
            InputProps={{
              readOnly: true,
              endAdornment: loading ? <CircularProgress size={20} sx={{ mr: 1 }} /> : <ExpandMore sx={{ color: 'action.active', mr: 1 }} />,
              ...InputProps,
            }}
            {...rest}
          />
          {!disableHelperText && (helperText || loading) && (
            <FormHelperText error={Boolean(error)} variant="filled">
              {helperText || (loading ? t('common.loading') : '')}
            </FormHelperText>
          )}
        </Wrapper>
      );
    }
  )
);
